import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import usePostCodes from '../../hooks/usePostCodes';
import Button from '../base/button';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import FormikSelect from '../base/forms/formikSelect';
import { StyledFormikField, StyledFormikTextArea } from '../base/forms/input';
import { Column, Columns } from '../base/grid';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: boolean;
	errors: any;
	touched: any;
}

const ContactFormFields: FC<Props> = ({ values, setFieldTouched, setFieldValue, isSubmitting }) => {
	const { t } = useTranslation(['generalForm', 'forms']);

	const { postCodes } = usePostCodes();

	const selectOptions = [
		{ value: '0', label: t('forms:missionOptions.option1') },
		{ value: '1', label: t('forms:missionOptions.option2') },
		{ value: '2', label: t('forms:missionOptions.option3') },
	];

	return (
		<div>
			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="mission"
						languageComponent="generalForm"
						label={`${t('forms:mission')}*`}
						smallLabel>
						<FormikSelect
							id="mission"
							name="mission"
							value={values.mission}
							options={selectOptions}
							placeholder={t('choose')}
							onBlur={setFieldTouched}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper name="name" languageComponent="generalForm" label={t('name')} smallLabel>
						<StyledFormikField type="text" id="name" name="name" placeholder={t('name')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper name="ssn" languageComponent="generalForm" label={t('ssn')} smallLabel>
						<StyledFormikField type="text" id="ssn" name="ssn" placeholder={t('ssn')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="email"
						languageComponent="generalForm"
						label={`${t('email')}*`}
						smallLabel>
						<StyledFormikField type="text" id="email" name="email" placeholder={t('email')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper name="phone" languageComponent="generalForm" label={t('phone')} smallLabel>
						<StyledFormikField type="text" id="phone" name="phone" placeholder={t('phone')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="trackingnumber"
						languageComponent="generalForm"
						label={t('trackingnumber')}
						smallLabel>
						<StyledFormikField
							type="text"
							id="trackingnumber"
							name="trackingnumber"
							placeholder={t('trackingnumber')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			{values.mission && values.mission.value === '0' && (
				<Columns>
					<Column desktopSmall={1 / 3} tablet={1 / 2}>
						<FormikFieldWrapper
							name="residence"
							languageComponent="generalForm"
							label={t('forms:residence')}
							smallLabel>
							<StyledFormikField
								type="text"
								id="residence"
								name="residence"
								placeholder={t('forms:residence')}
							/>
						</FormikFieldWrapper>
					</Column>
					<Column desktopSmall={1 / 3} tablet={1 / 2}>
						<FormikFieldWrapper name="zip" languageComponent="generalForm" label="Póstnúmer" smallLabel>
							<FormikSelect
								id="zip"
								name="zip"
								value={values.zip}
								options={postCodes}
								placeholder={t('zip')}
								onBlur={setFieldTouched}
								onChange={setFieldValue}
							/>
						</FormikFieldWrapper>
					</Column>
				</Columns>
			)}

			<Columns>
				<Column desktopSmall={2 / 3}>
					<FormikFieldWrapper
						name="comments"
						label={t('forms:comments')}
						smallLabel
						languageComponent="generalForm">
						<StyledFormikTextArea
							type="text"
							component="textarea"
							id="comments"
							name="comments"
							padding="1rem"
							placeholder={t('forms:comments')}
						/>
					</FormikFieldWrapper>
				</Column>
			</Columns>

			<Columns>
				<Column>
					<Button wide primary type="submit" isLoading={isSubmitting}>
						{t('submit')}
					</Button>
				</Column>
			</Columns>
		</div>
	);
};

export default ContactFormFields;
